import "./style.css";
import { AiOutlineGoogle } from "react-icons/ai";
import FramePencil from "../../../assets/images/icons/FramePencil.png";
import GoogleAuth from "../../Google/GoogleAuth/GoogleAuth";
import { useContext } from "react";
import dataContext from "../../../context/dataContext";
import authRequets from "../../api/authRequests";
import { useNavigate } from "react-router-dom";
import mainContext from "../../../context/mainContext";

// Creator : Team D - Dov
function FooterGoogle({ CreateAccount }) {
  const { setUserDetails } = useContext(dataContext);
  const navigate = useNavigate();
  const {
    loader: { setLoaderFetch }
  } = useContext(mainContext);
  const signInWithGoggle = async () => {
    try {
      setLoaderFetch(true);
      let userDetails = await authRequets.googleLogin()
      setUserDetails(userDetails);
      setTimeout(() => {
        setLoaderFetch(false);
        navigate("/")
      }, 250);
    } catch (error) {
      setLoaderFetch(false)
      console.log("🚀 ~ file:~ signInWhithGoggle ~ error:", error);
    }
  }
  return (
    <>
      <div className="footer-google" onClick={signInWithGoggle}>
        <div className="google-button">
          <AiOutlineGoogle className="google-icon" />
          <p >
            Login with Google
          </p>
        </div>
        {CreateAccount && (
          <div className="FramePencil">
            <img src={FramePencil} alt="img" />
          </div>
        )}
      </div>
    </>
  );
}

export default FooterGoogle;
